/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-28 20:51:15
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-07-09 17:58:13
 */
const STATUS = {
  0: "已取消",
  1: "待付款",
  2: "待预约",
  3: "服务中",
  4: "已完成",
  5: "退款中",
  6: '待派单',
  7: '派单成功',
  8: '正在服务'
};
const STATUSTYPE = {
  3: '派单'
}
export default (Vue) => {
  return [
    {
      title: "订单号",
      key: "orderNum",
      minWidth: 230,
      align: 'center'
    },
    {
      title: "服务信息",
      key: "orderProductBoList",
      minWidth: 230,
      align: 'left',
      render: (h, { row }) => {
        return h('div', row.orderProductBoList.map((list, i) => {
          return h('p', {}, `${i + 1}、${list.productName}`)
        }));
      }
    },
    {
      title: "订单状态",
      key: "state",
      minWidth: 100,
      align: 'center',
      render: (h, { row }) => {
        const text = STATUS[String(row.state)];
        return h('span', {
        }, text);
      }
    },
    {
      title: "订单总计(元)",
      key: "totalPrice",
      align: 'center',
      minWidth: 240
    },
    {
      title: "服务地址",
      key: "address",
      align: 'center',
      minWidth: 240
    },
    {
      title: "购买人手机号",
      key: "phone",
      align: 'center',
      minWidth: 100
    },
    {
      title: "下单时间",
      key: "createDt",
      align: 'center',
      minWidth: 180
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 120,
      render: (h, { row }) => {
        const text = STATUSTYPE[row.state]
        const buttons = [
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                Vue.$router.push({ path: '/orderdetail', query: { orderId: row.orderId } });
              }
            }
          }, '详情')
        ];
        
        // 为状态 1、2、3、6 添加取消订单按钮
        if ([1, 2, 3, 6].includes(row.state)) {
          buttons.push(
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
              },
              style: {
                color: "#FF4D4F",
                marginLeft: "8px"
              },
              on: {
                click: () => {
                  Vue.handleCancelOrder(row.orderId, row.orderNum);
                }
              }
            }, '取消订单')
          );
        }
        
        return h('div', buttons);
      }
    }
  ]
}